module.exports = __webpack_public_path__ + "static/logo_wxi-25120e61ee6fd2c1db8f333528320111.png";